import GastroErcpList from "./pages/GastroErcpList.vue"
import GastroErcpView from "./pages/GastroErcpView.vue"
import GastroErcpEdit from "./pages/GastroErcpEdit.vue"

export default{
    GastroErcpList,
    GastroErcpView,
    GastroErcpEdit
}
